import { WorkflowDeclineType } from "../constants";

/** Prepares prefix for declining workflow endpoint */
export function prepareDeclineType(declineType: WorkflowDeclineType) {
  return declineType.toLowerCase();
}
